/**
 * plp-oos-count.js
 *
 * Sold-out products are hidden from the collection / search grid server-side
 * (see main-collection-product-grid, extended-sizes-collection-product-grid and
 * main-search). Shopify's `results.products_count` still counts those hidden
 * products, so the "N products" label reads too high. This script subtracts the
 * number of hidden products (emitted in `.oos-hidden-count[data-hidden-count]`)
 * from the displayed count, and re-applies the adjustment after the facets AJAX
 * re-renders the count.
 */
(function () {
  var HIDDEN_SELECTOR = '.oos-hidden-count';
  var COUNT_CONTAINER_SELECTOR = '.thb-filter-count';
  var LABEL_SELECTOR = '.facets__label';
  var ADJUSTED_ATTR = 'data-oos-adjusted';

  function getHiddenCount() {
    var node = document.querySelector(HIDDEN_SELECTOR);
    if (!node) return 0;
    var n = parseInt(node.getAttribute('data-hidden-count'), 10);
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function adjustLabel(label, hidden) {
    if (!label || label.getAttribute(ADJUSTED_ATTR) === '1') return;
    // Subtract from the first number in the label (e.g. "48 products" or
    // "12 of 48 products" -> the visible/filtered product count comes first).
    var replaced = false;
    label.textContent = label.textContent.replace(/\d[\d,]*/, function (match) {
      if (replaced) return match;
      replaced = true;
      var n = parseInt(match.replace(/,/g, ''), 10);
      if (isNaN(n)) return match;
      return Math.max(n - hidden, 0).toLocaleString();
    });
    label.setAttribute(ADJUSTED_ATTR, '1');
  }

  function adjustAll() {
    var hidden = getHiddenCount();
    if (hidden < 1) return;
    var labels = document.querySelectorAll(
      COUNT_CONTAINER_SELECTOR + ' ' + LABEL_SELECTOR
    );
    for (var i = 0; i < labels.length; i++) {
      adjustLabel(labels[i], hidden);
    }
  }

  function observeCountContainers() {
    var containers = document.querySelectorAll(COUNT_CONTAINER_SELECTOR);
    if (!containers.length || typeof MutationObserver === 'undefined') return;
    // renderProductCount() in facets.js swaps each container's innerHTML with the
    // freshly fetched (un-adjusted) markup. The new label has no ADJUSTED_ATTR,
    // so re-running adjustAll re-applies it. Our own edit re-triggers the
    // observer, but the guard attribute makes that pass a no-op (no loop).
    var observer = new MutationObserver(function () {
      adjustAll();
    });
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i], {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  function init() {
    adjustAll();
    observeCountContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
